export default __webpack_public_path__ + "static/media/Group739.d0e60c62.svg";